import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false,
    user: null,
    userEmail: null,
    loginDate: null,
    signUpResponse: null,
    actualPage: null
  },
  mutations: {
    setAuthentication (state, status) {
      state.authenticated = status
    },
    setUser (state, user) {
      state.user = user
    },
    setUserEmail (state, userEmail) {
      state.userEmail = userEmail
    },
    setLoginDate (state, loginDate) {
      state.loginDate = loginDate
    },
    setSignUpResponse (state, signUpResponse) {
      state.signUpResponse = signUpResponse
    },
    setActualPage (state, actualPage) {
      state.actualPage = actualPage
    }
  },
  actions: {
  },
  modules: {
  }
})
